import { render } from "./SidebarMenu.vue?vue&type=template&id=280abdfc&ts=true"
import script from "./SidebarMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenu.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "280abdfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('280abdfc', __exports__)) {
    api.reload('280abdfc', __exports__)
  }
  
  module.hot.accept("./SidebarMenu.vue?vue&type=template&id=280abdfc&ts=true", () => {
    api.rerender('280abdfc', render)
  })

}


export default __exports__